<template>
  <div v-if="isLeapYearPromoActive && showSmallPrint" class="leap-year-small-print">
    <div class="leap-year-small-print__content">
      <div class="leap-year-small-print__title">Small Print You’re Going to Want to Read:</div>
      <div class="leap-year-small-print__text">
        Discounts cannot be applied to previous orders or be combined with any other offer. We
        reserve the right to change or discontinue this offer at any time.
      </div>
    </div>
    <div class="leap-year-small-print__content">
      <ul>
        <li>
          <span class="leap-year-small-print__title">
            This offer is valid February 20, 2024 - March 1, 2024
          </span>
        </li>
        <li>
          <span class="leap-year-small-print__title">
            Premium Subscription + Certification&nbsp;
          </span>
          <span class="leap-year-small-print__text">
            INE Premium will auto-renew annually at the published rate (USD) after the initial
            purchase cost unless canceled prior to the subscriber’s renewal date. Offer valid on new
            INE Security exam vouchers. Once purchased, the INE Security Certification exam voucher
            will be in your account and available to attempt for 180 days. You will have two
            attempts to pass the certification exam. This offer excludes ICCA.
          </span>
        </li>
        <li>
          <span class="leap-year-small-print__title"> INE Security Certifications&nbsp; </span>
          <span class="leap-year-small-print__text">
            Offer valid on new INE Security exam vouchers. Once purchased, the INE Security
            Certification exam voucher will be in your account and available to attempt for 180
            days. You will have two attempts to pass the certification exam. eJPT, eWPT, and eEDA
            can only be purchased with Premium subscription or a +3 plan. This offer excludes ICCA.
          </span>
        </li>
        <li>
          <span class="leap-year-small-print__title">Fundamentals Annual + eJPT&nbsp;</span>
          <span class="leap-year-small-print__text">
            This option is for new subscribers only. INE Fundamentals Annual will auto-renew
            annually at the published rate (USD) after the initial purchase cost of $199 unless
            canceled prior to the subscriber’s renewal date. Discounts cannot be applied to previous
            orders or be combined with any other offer. We reserve the right to change or
            discontinue this offer at any time.
          </span>
        </li>
        <li>
          <span class="leap-year-small-print__title"
            >ISC2 CISSP <span class="leap-year-small-print__text">and</span> CompTIA
            Security+&nbsp;</span
          >
          <span class="leap-year-small-print__text">
            certifications offered by third-party vendors. INE provides training only for these
            certifications. Certification vouchers are not included in this promotion.
          </span>
        </li>
      </ul>

      <div class="leap-year-small-print__text">
        If you have any questions, please email us at&nbsp;
        <a class="leap-year-small-print__link" href="mailto:support@ine.com">support@ine.com</a>.
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { routesRules } from '@/helpers/mixins'
import CONSTANTS from '@/constants'

const { PLANS, LEAP_YEAR_PROMO_PRODUCT_BUNDLES } = CONSTANTS

export default {
  name: 'LeapYearSmallPrint',
  mixins: [routesRules],
  computed: {
    ...mapState({
      certifications: state => state.products.availableCertifications,
      shoppingCart: state => state.shoppingCart.shoppingCart,
    }),
    ...mapGetters({
      isLeapYearPromoActive: 'app/isLeapYearPromoActive',
    }),
    cartHasPromoItem() {
      const certificationsWithPromo = this.certifications.filter(
        cert => cert.user_receives_discount
      )
      const promotionItemsCodes = [
        PLANS.ANNUAL,
        ...Object.values(LEAP_YEAR_PROMO_PRODUCT_BUNDLES),
        ...certificationsWithPromo.map(cert => cert.merchant_id),
      ]
      const cartHasPromoItem = this.shoppingCart.filter(item =>
        promotionItemsCodes.includes(item.merchant_id)
      )
      return cartHasPromoItem.length > 0
    },
    showSmallPrint() {
      if (this.isLeapYearPromoPage) {
        return true
      }
      return this.cartHasPromoItem
    },
  },
}
</script>

<style lang="scss" scoped>
.leap-year-small-print {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  align-self: stretch;
  margin-bottom: 60px;
  @include tablet {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 60px;
    align-self: stretch;
  }
  ul {
    margin: 0;
    padding-left: 15px;
    line-height: 12px;
    li {
      line-height: 12px;
      margin-bottom: 10px;
      &::marker {
        color: var(--boulder);
      }
    }
  }
  &__content {
    flex: 1 0 0;
  }
  &__content:first-child {
    @include tablet {
      max-width: 296px;
    }
  }
  &__title {
    color: var(--gray-9);
    font-size: rem(10px);
    font-style: normal;
    font-weight: 700;
    line-height: rem(12px);
  }
  &__text {
    color: var(--boulder);
    font-size: rem(10px);
    font-style: normal;
    font-weight: 450;
    line-height: rem(12px);
  }
  &__link {
    color: var(--light-purple);
    font-size: rem(10px);
    font-style: normal;
    font-weight: 450;
    line-height: rem(12px);
  }
}
</style>
